import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = '/login'
}) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <LoadingSpinner />
      </div>
    );
  }

  // If not authenticated, redirect to login with return URL
  if (!user) {
    return (
      <Navigate
        to={redirectTo}
        state={{ from: location }}
        replace
      />
    );
  }

  // Trial-first: we no longer bounce pending_payment users to /login. Under
  // the old pay-first flow this gate was "you didn't finish Stripe so go
  // back to login to restart checkout" — but under trial-first, signup
  // doesn't touch Stripe, so pending_payment is just legacy state that the
  // login backend self-heals to 'active' next time the user signs in.
  // Letting them through means no one gets trapped in a Stripe loop.
  return <>{children}</>;
};

export default ProtectedRoute;